<mat-card class="comentarios-card" *ngIf="formulario?.get('id')?.value">
  <div class="comentarios-header">
    <mat-card-title>
      <mat-icon>forum</mat-icon>
      Interações e Comentários
    </mat-card-title>
    <span class="comentarios-count">{{ comentarios.length }} comentários</span>
  </div>
  <mat-divider></mat-divider>

  <div class="comentarios-lista">
    <div class="comentario-item" *ngFor="let comentario of comentarios">
      <div class="avatar">
        <mat-icon class="avatar-icon">account_circle</mat-icon>
      </div>
      <div class="comentario-conteudo">
        <div class="comentario-header">
          <strong>{{ comentario.usuario || 'Usuário não identificado' }}</strong>
          <p>{{ "Apresentar Parceiro: " + (comentario.apresentarParceiro ? "Sim" : "Não") }}</p>
          <span class="comentario-data">{{ comentario.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <p class="comentario-texto">{{ comentario.texto }}</p>
        <div class="comentario-imagens" *ngIf="comentario.imagensBase64?.length">
          <ng-container *ngFor="let img of comentario.imagensBase64">
            <img *ngIf="isImageFile(img.nome)" [src]="img.base64" [alt]="img.nome"
              style="cursor:pointer" (click)="abrirPreviewImagem(img)">
            <a *ngIf="!isImageFile(img.nome)" class="comentario-anexo" [href]="img.base64"
              [download]="img.nome" [title]="img.nome">
              <mat-icon>attach_file</mat-icon>
              <span>{{ img.nome }}</span>
            </a>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="text-center mt-2" *ngIf="!lastPage && comentarios.length > 0">
      <button mat-stroked-button color="primary" (click)="carregarMais.emit()" [disabled]="loading">
        {{ loading ? 'Carregando...' : 'Carregar mais' }}
      </button>
    </div>
  </div>

  <div class="comentario-input-container">
    <div class="input-row">
      <textarea matInput rows="2" [ngModel]="novoComentario" (ngModelChange)="onNovoComentarioChange($event)"
        placeholder="Digite sua resposta..."></textarea>
      <button mat-flat-button color="primary" (click)="adicionarComentario.emit()"
        [disabled]="!novoComentario && imagensSelecionadas.length === 0" class="send-btn">
        <mat-icon>send</mat-icon>
      </button>
    </div>
    <input type="file" #fileInputComentario (change)="arquivoSelecionado.emit($event)" multiple hidden>
    <button mat-stroked-button color="accent" (click)="fileInputComentario.click()" class="upload-btn">
      <mat-icon>attach_file</mat-icon>
      Adicionar anexo
      <span class="preview-count" *ngIf="imagensSelecionadas.length > 0">{{ imagensSelecionadas.length }}</span>
    </button>
    <div [formGroup]="formulario">
      <mat-checkbox formControlName="apresentarParceiroInteracao" color="primary">
        Apresentar Interações para Parceiro
      </mat-checkbox>
    </div>
    <div class="preview-imagens" *ngIf="imagensSelecionadas.length > 0">
      <div class="imagem-preview" *ngFor="let img of imagensSelecionadas; let i = index">
        <img *ngIf="isImageFile(img.nome)" [src]="img.base64" [alt]="img.nome" (click)="abrirPreviewImagem(img)">
        <div *ngIf="!isImageFile(img.nome)" class="anexo-preview" [title]="img.nome">
          <mat-icon>insert_drive_file</mat-icon>
          <span>{{ img.nome }}</span>
        </div>
        <button type="button" (click)="removerImagem.emit(i)">×</button>
      </div>
    </div>
  </div>
</mat-card>

<ng-template #imageDialog let-data>
  <div class="image-dialog-container">
    <div class="image-dialog-header">
      <span class="image-title">{{ data.nome }}</span>
      <button mat-icon-button mat-dialog-close color="warn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="image-dialog-content">
      <img [src]="data.base64" [alt]="data.nome">
    </div>
    <div class="image-dialog-actions">
      <a mat-icon-button color="primary" [href]="data.base64" [download]="data.nome" matTooltip="Baixar arquivo">
        <mat-icon>download</mat-icon>
      </a>
    </div>
  </div>
</ng-template>
